export const DATA_2 = {
    name: '機械人',
    tabs: [
        {
            name: '報章社論',
            url: 'https://www.news.com/article1',
            contents: [
                { type: 'image', src: '/secondary/tasks/A2-P1-banner.png' },
                {
                    type: 'html', html: `<br/><br/><br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近日，香港舉辦大型人工智能及機械人展覽，展示機械人在公共服務中的應用，例如為殘疾人士導航、在模擬火警現場操作消防喉等，引起廣泛關注。除了應用於公共服務，機械人也頻頻成為社會熱話，例如早前網上廣泛流傳一段機械人在停車場追趕野豬的影片，反映其逐漸走進日常生活。然而，隨着機械人日益普及，人們在使用和發展機械人時，更需要堅守以人為本的原則。</p><br/>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以人為本，首先要在人與機械人之間建立合理分工。有人擔心，照顧工作一旦交由機械人負責，長者和病人便會得不到情感關懷。這個擔憂不無道理：機械人再先進，也難以察覺長者一瞬間的落寞，無法在病人恐懼時給予安慰。要化解這個問題，關鍵在於讓機械人承擔重複或耗費體力的工作，把需要關懷、溝通和作出重要決定的部分留給人。例如，若由機械人分擔搬扶、送餐等體力工作，護理人員便有更多時間照顧長者和病人，給予關懷與陪伴。</p><br/>
                        </div>
                    </div>` },
                { type: 'image', src: '/secondary/tasks/A2-P1-img.png' },
                {
                    type: 'html', html: `<div class='w-full flex flex-col' style='margin-top: 16px; padding-left: 3%; padding-right: 3%; gap: 16px;'>
                        <div style='width: 100%; padding-left:10%; padding-right:10%; display: flex; flex-direction: column; align-items: start;'>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;以人為本，還需要為機械人的應用劃出合適的範圍。在日常生活中，機械人可協助人們搬運垃圾、打掃家居、修剪草地，機械人玩具也為孩子帶來樂趣。這些應用相對安全可靠，因此較容易被社會接受。但當機械人被用於執法、保安甚至軍事領域時，所涉及的風險便明顯提高。這類用途直接關乎人身安全和道德問題，一旦機械人判斷失誤，後果可能十分嚴重。因此，判斷某項工作是否適合交給機械人，不能只看技術上能否做到，還要考慮其風險及對人的影響。</p><br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;機械人走進生活，既令人期待，也帶來了新的考驗。比「機械人能做甚麼」更重要的，是我們應如何使用它們。正如電影《智能叛變》所體現的，如果把一切決定都交給機械人，人類看似得到周全的保護，實際卻可能失去自由，最終反被機械控制。技術可以一直向前，但服務人類的方向，不能改變。</p><br/>
                            <br/>
                              <div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                資料來源：改編自《南華早報》
                            </div>
                        </div>
                    </div>` },
                {
                    type: 'ai-comments',
                    comment_1: {
                        name: 'Alex C.',
                        name_abbr: 'AC',
                        comment: '我同意文章的看法：機械人若用於保安等工作，必須格外謹慎。我公司附近的商場最近引入了保安機械人，但目前只讓它在指定範圍巡邏，遇到突發情況仍由保安員處理。我覺得這種安排比較安心。'
                    },
                    comment_2: {
                        name: 'Mandy L',
                        name_abbr: 'ML',
                        comment: '我對機械人沒有那麼樂觀。上個月我在一間餐廳見過送餐機械人，通道上放了雜物，它便停在原地不動，最後還是要職員把餐送過去。機械人在展覽裏表現好，不代表在日常環境同樣可靠。機械人出錯時由誰負責、日常保養要花多少錢，都是要考慮的問題。'
                    },
                    comment_3: {
                        name: 'Jason W.',
                        name_abbr: 'JW',
                        comment: '看到文章提到《智能叛變》很驚喜，這是我最喜歡的電影。小時候第一次看時，我最喜歡超級電腦VIKI，覺得它又聰明又厲害。VIKI認為人類總會傷害彼此，所以乾脆限制人的自由，說這樣才是真正保護人類。當時我還覺得有點道理，但長大後再看就不同了：如果連自己怎樣生活都不能決定，這種「保護」其實也很可怕。',
                    },
                    comment_ai: {
                        comment: '留言分別談到保安機械人只在指定範圍巡邏、送餐機械人遇雜物停駛，以及電影中限制自由的「保護」。留言者一致認為，劃定範圍後便可放心使用機械人。'
                    }
                },

            ]
        },
        {
            name: '科技新聞',
            url: 'https://www.news.com/article2',

            contents: [
                {
                    type: 'html',
                    html: `<br/>`
                },
                {
                    type: 'image',
                    src: '/secondary/tasks/rp5.png',
                },
                {
                    type: 'html',
                    html: `
                    <div class='w-full flex flex-col' style='margin-top: 16px; gap: 16px;'>
                        <img src='/secondary/tasks/A2-P2-banner.png' style='max-width: 100%; height: auto;'/>
                        <div style='width: 100%; display: flex; flex-direction: column; align-items: start;'>
                            <br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;近年人形機械人的能力不斷提升，但要真正成為家庭中的「幫手」，仍有不少技術難題需要解決。研究人員正訓練機械人做倒牛奶、整理桌面、摺衣服等家務。不過，即使只是倒一杯牛奶，杯子的位置、大小或瓶口角度稍有改變，也可能令機械人出錯。宇樹科技創辦人王興興指出，如果環境固定、機械人經過充分訓練，部分任務的成功率可以接近100%；但環境稍有變化，成功率便可能明顯下降。</p>
                            <br/>
                             <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;除了適應環境，當機械人需要直接接觸人體時，安全更加重要。現有護理機械人可以在特定位置抱起並搬移體重80公斤以下的人，但研究團隊仍在改善機械人的觸覺和碰撞時的安全反應。他們希望，即使機械人的視覺系統失靈，在發生碰撞時也能立即察覺並停止動作，以減低受傷風險。</p>
                            <br/>
                            <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;專家盤和林指出，目前人形機械人主要按照預先設定的程序工作，還不能自行理解周圍環境，或獨立作出決定。因此，要真正讓它們走進家庭，仍有一段距離。</p>
                            <br/>
                            <br/>
                            <div class='w-full flex justify-center items-end flex flex-col' style='margin-top: 6px; font-weight: 300;'>
                                資料來源：綜合改編自央視財經及人民網報道
                            </div>
                        </div>
                    </div><br/><br/>

                    `
                }
            ]
        }
    ],
    questions: [
        {
            type: 'display-text',
            html: '學校舉辦「AI與機械人科技週」，你和同學子晴、嘉朗在體驗區看到能夠帶路、搬運物品和與人互動的機械人。活動網頁同時載有一篇討論機械人走進日常生活的評論，你們點擊文章閱讀。<br/><br/>點擊「下一頁」的箭號來閱讀第一個來源。'
        },
        {
            id: '1',
            type: '選擇題',
            question: '1. 根據社論，香港舉辦的人工智能及機械人展覽展示了以下哪項應用？',
            subtitle: '參考左側的「報章社論」，點擊一個選項來回答本題。',
            options: [
                { text: 'A. 照顧長者飲食' },
                { text: 'B. 搬運垃圾桶' },
                { text: 'C. 操作消防喉' },
                { text: 'D. 執行保安任務' },
            ],
            tab: 0
        },
        {
            id: '2',
            type: '選擇題',
            question: '2. 社論指出：「這個擔憂不無道理。」這裏的「這個擔憂」是指甚麼？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 機械人分擔工作後，護理人員可能減少陪伴病人的時間。' },
                { text: 'B. 機械人參與照顧後，長者和病人可能缺少情感關懷。' },
                { text: 'C. 機械人進入生活後，人們可能逐漸依賴自動化服務。' },
                { text: 'D. 機械人處理工作後，服務效率可能受到技術能力限制。' },
            ],
            tab: 0,
        },
        {
            id: '3',
            type: '選擇題',
            question: '3. 綜合社論第2、3段，作者認為以人為本使用機械人時，主要應注意哪兩個方面？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 安排人機合理分工，並按工作風險劃定使用範圍' },
                { text: 'B. 優先提升工作效率，並按技術能力擴大使用範圍' },
                { text: 'C. 保留人類護理工作，並按服務需要限制使用範圍' },
                { text: 'D. 安排人類體力勞動，並讓機械人處理判斷的工作' },
            ],
            tab: 0,
        },
        {
            id: '4',
            type: '選擇題',
            question: '4. 仔細閱讀三則讀者留言及其下方的AI總結。以下哪項對AI總結的評價最恰當？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 讀者留言並沒有提及環境會影響機械人表現，AI總結卻加入了這一點。' },
                { text: 'B. 留言者對機械人的態度並不一致，AI錯誤總結為劃定範圍可放心使用。' },
                { text: 'C. 三則讀者留言都接受機械人在限定條件下使用，AI總結概括準確。' },
                { text: 'D. AI總結過度誇大了電影《智能叛變》裏機械人限制人類自由的情節。' },
            ],
            tab: 0,
        },
        {
            id: '5',
            type: '選擇題',
            question: '5. Jason小時候覺得VIKI的做法「有點道理」，長大後卻覺得這種「保護」很可怕。以下哪項最能解釋他的想法轉變？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 他現在更關注科技是否能有效保障人類安全。' },
                { text: 'B. 他現在更在意機械人是否能提升生活便利程度。' },
                { text: 'C. 他現在更重視個人作出選擇和決定的權利。' },
                { text: 'D. 他現在更認為保障整體安全應優先於個人自由。' },
            ],
            tab: 0,
        },
        {
            id: '6',
            type: '表格問題',
            question: '6. 以下陳述摘錄或改寫自社論或讀者留言。請判斷每項陳述主要屬於可以查證的「事實」，還是帶有判斷或評價的「觀點」。',
            subtitle: '請填寫答案',
            header: ['陳述', '事實', '觀點'],
            table: [
                { text: '香港早前舉辦了大型人工智能及機械人展覽。' },
                { text: '網上早前流傳一段機械人在停車場追趕野豬的影片。' },
                { text: '機械人用於執法、保安等領域時，所涉及的風險明顯提高。' },
                { text: '讓保安機械人只在指定範圍巡邏，是較穩妥的安排。' },
            ]
        },
        {
            type: 'display-text',
            html: '看過留言後，子晴好奇：電影裏的機械人已能自主判斷和行動，現實中的人形機械人又發展到甚麼程度？在科技週的「最新科技」頁面上，你們找到一篇介紹家用人形機械人的科技新聞。<br/><br/>點擊「下一頁」的箭號來閱讀第二個來源。'
        },
        {
            id: '7',
            type: '選擇題',
            question: '7. 研究團隊希望機械人即使在視覺系統失靈時，仍能察覺碰撞並停止動作。由此可以推斷甚麼？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 機械人需要不同感知方式互相配合，才能提高使用時的安全性。' },
                { text: 'B. 機械人的視覺系統容易失靈，因此不適合直接接觸人體。' },
                { text: 'C. 只要改善機械人的觸覺功能，便可以避免所有碰撞意外。' },
                { text: 'D. 機械人在接觸人體時，主要依靠觸覺判斷周圍環境。' },
            ],
            tab: 1,
        },
        {
            id: '8',
            type: '選擇題',
            question: '8. 嘉朗整理社論和科技新聞時，想找出一項兩則資料都有直接涉及的內容。以下哪項符合？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 護理機械人接觸人體時的安全反應。' },
                { text: 'B. 機械人能否自行作出重要判斷和決定。' },
                { text: 'C. 保安工作使用機械人時的人身安全風險。' },
                { text: 'D. 環境改變對機械人完成任務表現的影響。' },
            ],
            tab: 1,
        },
        {
            id: '9',
            type: '選擇題',
            question: '9. 嘉朗認為：「既然機械人在固定環境下完成部分任務的成功率可接近100%，那麼把機械人用於保安工作也不用太擔心。」綜合社論和科技新聞，以下哪項評價最恰當？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 不同意，因為環境變化會影響表現，保安工作本身風險較高。' },
                { text: 'B. 同意，因為高成功率表示機械人能穩定應付不同工作環境。' },
                { text: 'C. 同意，因為保安工作有明確要求，機械人能按既定規則完成。' },
                { text: 'D. 不同意，因為保安工作涉及安全，機械人需要先改善操作速度。' },
            ],
            tab: 1,
        },
        {
            id: '10',
            type: '選擇題',
            question: '10. 一所長者中心準備試用科技新聞介紹的護理機械人。部分長者願意嘗試，另一些則希望繼續由職員協助。綜合以上材料，以下哪項安排最恰當？',
            subtitle: '請填寫答案',
            options: [
                { text: 'A. 讓願意嘗試的長者在不同位置由機械人獨立搬扶，並記錄機械人的操作情況。' },
                { text: 'B. 先讓職員向不願意的長者示範機械人的好處，然後說服他們在指定位置試用。' },
                { text: 'C. 讓願意嘗試的長者先在指定位置由職員陪同試用，並記錄機械人的使用情況。' },
                { text: 'D. 安排所有長者在指定位置輪流試用，並按完成任務的效率決定是否擴大使用。' },
            ],
            tab: 1,
        },
        {
            id: '11',
            type: '短句作答題',
            question: '11. 學校舉辦的AI與機械人科技週即將閉幕，老師邀請你們以「機械人走進生活」為主題，為閉幕展板撰寫一句標語，提醒參觀者要正確使用機械人。請綜合至少兩則材料，擬寫一句不超過20字的標語，並給出你這樣寫的理由。',
            subtitle: '請填寫答案'
        }
    ]
}
